import { NgTemplateOutlet } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  TemplateRef,
} from '@angular/core'
import { focusElementInContainer } from '../util'
import { PopoverRole } from './popover.constants'

/**
 * This component is a container for overlay content handled by the popover directive. It should
 * not be used on its own.
 */
@Component({
  selector: 'ftr-popover',
  template: '<ng-container *ngTemplateOutlet="content()" />',
  styleUrl: './popover.component.css',
  host: {
    '[id]': 'id()',
    '[attr.role]': 'role()',
    '[attr.aria-modal]': 'false',
    '[attr.aria-label]': 'ariaLabel() || null',
    '[attr.aria-labelledby]': 'ariaLabelledBy() || null',
    class: 'popover',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class PopoverOutlet implements AfterViewInit {
  private readonly elementRef = inject(ElementRef)

  readonly id = input.required<string>()
  readonly content = input.required<TemplateRef<any>>()
  readonly autoFocus = input<boolean>(true)
  readonly role = input<PopoverRole>('dialog')
  /** Accessible name for the popover. Prefer ariaLabelledBy when a visible title exists. */
  readonly ariaLabel = input<string>()
  /** ID of a visible labelling element (e.g. the popover heading). Takes precedence over ariaLabel. */
  readonly ariaLabelledBy = input<string>()

  ngAfterViewInit(): void {
    if (this.autoFocus()) {
      focusElementInContainer(this.elementRef.nativeElement, 'first')
    }
  }
}
